<section class="profile-insured">

    <app-profile-section-header title="Mis asegurados" subtitle="Gestiona los asegurados de tu póliza.">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
            <circle cx="9" cy="8" r="3.5"/>
            <path d="M2.5 20c0-3.3 2.9-5.5 6.5-5.5s6.5 2.2 6.5 5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="17" cy="9" r="2.5"/>
            <path d="M14.5 14.5c2.5 0 5 1.6 5 4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <button headerActions type="button" class="pi-add" (click)="openModal()">
            <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M10 4v12M4 10h12" stroke-linecap="round"/>
            </svg>
            <span>Añadir asegurado</span>
        </button>
    </app-profile-section-header>

    <aside class="pi-info">
        <span class="pi-info-icon">
            <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                <circle cx="10" cy="10" r="8"/>
                <path d="M10 7v4M10 14h.01" stroke-linecap="round"/>
            </svg>
        </span>
        <div class="pi-info-text">
            <h4>¿Qué puede hacer un asegurado?</h4>
            <ul>
                <li>Consultar a un abogado por chat o teléfono y hacer seguimiento de sus expedientes.</li>
                <li>Abrir y gestionar sus propias reclamaciones de forma autónoma.</li>
            </ul>
            <p class="pi-info-note"><strong>Ten en cuenta:</strong></p>
            <ul>
                <li>Solo pueden darse de alta asegurados mayores de edad que residan en la misma vivienda. Las consultas o gestiones de menores deben realizarse desde el perfil de su padre, madre o tutor legal.</li>
                <li>Los asegurados que no sean familiares directos ni pareja deberán aportar un certificado de empadronamiento que acredite al menos 6 meses de convivencia al abrir un expediente.</li>
            </ul>
        </div>
    </aside>

    <div *ngIf="loading" class="pi-loading">Cargando<span>.</span><span>.</span><span>.</span></div>

    <div *ngIf="!loading && insureds.length === 0" class="pi-empty">
        Aún no has añadido asegurados a tu póliza.
    </div>

    <div class="pi-list" *ngIf="!loading && insureds.length > 0">
        <article class="pi-card" *ngFor="let i of insureds; trackBy: trackById">
            <header class="pi-card-head">
                <div class="pi-card-id">
                    <h3>{{ i.fullName }}</h3>
                    <span class="pi-tag" *ngIf="i.relationship">{{ relationshipLabel(i.relationship) }}</span>
                </div>
                <div class="pi-actions">
                    <button type="button" class="pi-edit" aria-label="Modificar asegurado" (click)="openEditModal(i)">
                        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                            <path d="M13.5 3.5a1.5 1.5 0 0 1 2.12 0l0.88 0.88a1.5 1.5 0 0 1 0 2.12l-8.5 8.5-3.5 1 1-3.5 8-8Z" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 5l3 3" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <button type="button" class="pi-delete" aria-label="Eliminar asegurado" (click)="remove(i)">
                        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
                            <path d="M3 5h14M8 5V3h4v2M5 5l1 12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2l1-12" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 9v7M11 9v7" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>
            </header>

            <div class="pi-card-policy" *ngIf="i.product || i.policySequence">
                <span class="pi-field" *ngIf="i.product">
                    <span class="pi-field-icon">
                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">
                            <path d="M8 1.7 13 3.6v3.9c0 3-2.1 4.8-5 6-2.9-1.2-5-3-5-6V3.6L8 1.7Z" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span class="pi-field-text">Seguro: {{ i.product }}</span>
                </span>
                <span class="pi-card-policy-sep" *ngIf="i.product && i.policySequence" aria-hidden="true"></span>
                <span class="pi-field" *ngIf="i.policySequence">
                    <span class="pi-field-text">Póliza: {{ i.policySequence }}</span>
                </span>
            </div>

            <div class="pi-card-grid">
                <div class="pi-field">
                    <span class="pi-field-icon">
                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">
                            <path d="M4 2h2l1.5 3.5L6 7a8 8 0 0 0 3 3l1.5-1.5L14 10v2a2 2 0 0 1-2 2A10 10 0 0 1 2 4a2 2 0 0 1 2-2z" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span class="pi-field-text">{{ formatPhone(i) }}</span>
                </div>

                <div class="pi-field">
                    <span class="pi-field-icon">
                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">
                            <rect x="2" y="3" width="12" height="11" rx="1.5"/>
                            <line x1="2" y1="6.5" x2="14" y2="6.5"/>
                            <line x1="5" y1="1.5" x2="5" y2="4.5"/>
                            <line x1="11" y1="1.5" x2="11" y2="4.5"/>
                        </svg>
                    </span>
                    <div class="pi-field-multiline">
                        <span class="pi-field-label">Fecha de nacimiento:</span>
                        <span class="pi-field-text">{{ i.bornDate }}</span>
                    </div>
                </div>

                <div class="pi-field" *ngIf="i.documentNumber">
                    <span class="pi-field-icon">
                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">
                            <rect x="2" y="4" width="12" height="9" rx="1.5"/>
                            <circle cx="6" cy="8" r="1.5"/>
                            <path d="M3 11c1-1.5 4-1.5 5 0M10 7h3M10 10h3" stroke-linecap="round"/>
                        </svg>
                    </span>
                    <span class="pi-field-text">DNI: {{ i.documentNumber }}</span>
                </div>

                <div class="pi-field pi-field--full" *ngIf="i.email">
                    <span class="pi-field-icon">
                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">
                            <rect x="2" y="3" width="12" height="10" rx="1.5"/>
                            <path d="M2 5l6 4 6-4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span class="pi-field-text">{{ i.email }}</span>
                </div>
            </div>
        </article>
    </div>

    <app-insured-modal [show]="modalOpen"
                       [insured]="editingInsured"
                       [policies]="policies"
                       (closed)="closeModal()"
                       (saved)="onSave($event)">
    </app-insured-modal>

    <app-modal-dialog [show]="confirmDeleteOpen" title="Eliminar asegurado" [width]="480"
                      [closeOnBackdrop]="!deleting"
                      (closed)="cancelDelete()">
        <p class="pi-confirm-text" *ngIf="insuredToDelete">
            ¿Seguro que quieres eliminar a <strong>{{ insuredToDelete.fullName }}</strong> como
            asegurado de tu póliza? Esta acción no se puede deshacer.
        </p>
        <div modal-footer class="pi-confirm-actions">
            <button type="button" class="pi-confirm-cancel" (click)="cancelDelete()" [disabled]="deleting">
                Cancelar
            </button>
            <button type="button" class="pi-confirm-delete" (click)="confirmDelete()" [disabled]="deleting">
                {{ deleting ? 'Eliminando...' : 'Eliminar' }}
            </button>
        </div>
    </app-modal-dialog>

</section>
